// extracted by mini-css-extract-plugin
module.exports = {"toast":"style_toast__3384F","text":"style_text__xL7gn","icon":"style_icon__a4wNW","success":"style_success__5JQwS","error":"style_error__vzkGa","info":"style_info__iULwZ"};